"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ToggleTool_exports = {};
__export(ToggleTool_exports, {
  default: () => ToggleTool_default
});
module.exports = __toCommonJS(ToggleTool_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.3282 6.53945L13.1321 3.53945C12.7494 3.31853 12.2601 3.44963 12.0392 3.83227L9.05551 9.00022H12C13.1046 9.00022 14 9.89565 14 11.0002V15.5863C14.0459 15.5393 14.0867 15.486 14.121 15.4265L18.621 7.63227C18.8419 7.24963 18.7108 6.76036 18.3282 6.53945ZM11 3.23227L7.66987 9.00022H6C4.89543 9.00022 4 9.89565 4 11.0002V20.0002C4 21.1048 4.89543 22.0002 6 22.0002H12C13.1046 22.0002 14 21.1048 14 20.0002V16.943C14.4726 16.8021 14.8942 16.4873 15.1603 16.0265L19.6603 8.23227C20.2125 7.27568 19.8848 6.0525 18.9282 5.50022L13.7321 2.50022C12.7755 1.94793 11.5523 2.27568 11 3.23227ZM12.8 20.0002V16.9257C12.6731 16.8836 12.5485 16.828 12.4282 16.7585L7.23205 13.7585C6.27547 13.2063 5.94772 11.9831 6.5 11.0265L6.97705 10.2002H6C5.55817 10.2002 5.2 10.5584 5.2 11.0002V20.0002C5.2 20.442 5.55817 20.8002 6 20.8002H12C12.4418 20.8002 12.8 20.442 12.8 20.0002Z",
      fill: "currentColor"
    }
  )
);
const SvgToggleTool = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ToggleTool_default = SvgToggleTool;
